import { render, staticRenderFns } from "./myStory.vue?vue&type=template&id=0b5c2cce&scoped=true&"
import script from "./myStory.vue?vue&type=script&lang=js&"
export * from "./myStory.vue?vue&type=script&lang=js&"
import style0 from "./myStory.vue?vue&type=style&index=0&id=0b5c2cce&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5c2cce",
  null
  
)

export default component.exports